import { convertWeblabTagsToCssClasses } from '../../utils/weblab-helpers';
import { fireReadyEvent } from './events';

// Ensures that, if applicable, weblab tags are applied as classes on the
// <body> for experiments being run on the components.
let weblabStylesApplied = false;
const applyWeblabStyles = () => {
  if (!weblabStylesApplied) {
    convertWeblabTagsToCssClasses();
    weblabStylesApplied = true;
  }
};

export const register = (tagName: string) => descriptor => ({
  ...descriptor,
  finisher(clazz) {
    registerImpl(tagName, clazz);
  },
});

// exported for testing
export function registerImpl(tagName: string, clazz: any) {
  if (!window.customElements.get(tagName)) {
    applyWeblabStyles();

    window.customElements.define(tagName, clazz);

    fireReadyEvent(tagName, 'katal-component-ready');
  }
}
